/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space, Typography } from "antd";
import { Button, TextField, Box } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { SupplierGroupTable } from "./SupplierGroupTable";
import { NavLink } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { toast } from 'react-toastify';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { useEventListener } from "../../../../../helpers/useEventListener";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { emptyValidation } from "../../../../../helpers/validation";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const SuppliersGroup = (props) => {

    const { supplierGroupDetails, loader } = useSelector(state => state.purchaseSetupReducer);
    const { createDetails, createError, createLoader, getList, getData, editLoader, editDetails, editError } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();

    const [visible, setVisible] = useState(false);
    //const [errorName, setErrorName] = useState(false);
    const [addMore, setAddMore] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    // const [errorDescription, setErrorDescription] = useState(false);
    //  const [name, setName] = useState('');
    // const [description, setDescription] = useState('');
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;
    const [deleteModal, setDeleteModal] = useState(false);
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [view, setView] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);


    const handleOpen = () => {
        setVisible(true);
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };


    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Supplier Group', history, 'Purchase')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) {
            e.preventDefault();
            setVisible(true);
        } else if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            createGroup(e);
        }
    }
    useEventListener("keydown", handleKeyDown);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'supplier-group',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    const emptyState = () => {
        setError({})
    };

    const emptyStateInput = () => {
        setForm({});
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            loadTasks();
            setVisible(false);
            toast.dismiss();
            //toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            setError({
                name: createError?.error?.message
            })
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            //toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            setError({
                name: editError?.error?.message
            })
        }
    }, [editDetails, editError]);

    const handleAddMore = (e) => {
        createGroup(e);
        setAddMore(true);
    }
    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }


    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.SUPPLIERGROUP_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'supplier-group',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const changeHandler = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    }

    const onHandle = (data, view, visible) => {
        setForm(data);
        setVisible(visible);
        setView(view);
    };

    const createGroup = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Group', form?.name);
        emptyState();
        if (emptyName.isValid) {
            Object.keys(form).forEach(k => !Number.isInteger(form[k]) && (form[k] = form[k].trim()));
            dispatch({
                type: form.id ? crudActions.EDIT_DETAILS_START
                    : crudActions.CREATE_DETAILS_START,
                url: 'supplier-group',
                title: 'Supplier Group',
                id: form.id,
                // details: {
                //     name: name,
                //     description: description
                // }
                details: form
            });
        } else {
            if (emptyName.errors) {
                setError({
                    name: emptyName.errors
                })
            }
        }
    }


    const onDelete = (data) => {
        setForm(data);
        setDeleteModal(true);
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Supplier Group', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Supplier Group'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Supplier Group', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Group and Description'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                id={idNamingConversion('Search', 'supplierGroup', 'TextField')}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Group', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'supplierGroup', 'Link')}
                                                    onClick={() => { loadImportExportData('SupplierGroup'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Group', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Import', 'supplierGroup', 'Link')}
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Supplier Group', 'create', 'Purchase') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Add New Group', 'supplierGroup', 'Link')}
                                                    onClick={() => onHandle({}, false, true)}
                                                    className={clsx(classes.customLink, classes.disInline, classes.cursor)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add New Group</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Group', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <SupplierGroupTable
                                search={search}
                                onHandle={(data, view, visible) => onHandle(data, view, visible)}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                onDelete={(data) => onDelete(data)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortBy={sortBy} sortOrder={sortOrder}
                                roleManagement={roleManagement}
                                handleOpen={() => handleOpen()}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />

                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${view ? 'View' : (form?.id ? 'Edit' : 'Add')} Supplier Group`}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createGroup(e)}>
                        <div className={classes.customFormFlex}>
                            {
                                view ?
                                    <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Supplier Group</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.name ? form.name : '---'}</Typography>
                                    </> :

                                    <TextField autoComplete='one-time-code'
                                        label={["Supplier Group ", <span key={"Supplier Group"} className={classes.colorRedRequired}> *</span>]}
                                        variant={'standard'}
                                        value={form?.name}
                                        name={'name'}
                                        id={idNamingConversion('Supplier Group', 'supplierGroup', 'TextField')}
                                        error={error?.name ? true : false}
                                        helperText={error?.name}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => { changeHandler(e); }}
                                    />
                            }
                            {


                                view ?
                                    <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Description</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description ? form.description : '---'}</Typography>
                                    </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Description "]}
                                        name={"description"}
                                        value={form?.description}
                                        multiline
                                        id={idNamingConversion('Description', 'supplierGroup', 'TextField')}
                                        variant="outlined"
                                        className={clsx(classes.margin30t, classes.customDescription)}
                                        rows={4}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColor,
                                        }}
                                        onChange={(e) => { changeHandler(e); }}
                                    />
                            }
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                {
                                    !view ? <><Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        id={idNamingConversion('Save', 'supplierGroup', 'Button')}
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                        {form?.id ? 'Update & Close' : 'Save & Close'}
                                    </Button> {
                                            !form?.id && <Button
                                                key="add"
                                                color='primary'
                                                variant="contained"
                                                onClick={(e) => handleAddMore(e)}
                                                id={idNamingConversion('Add More', 'supplierGroup', 'Button')}
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader || editLoader })}>
                                                Add More
                                            </Button>
                                        }</> : <NavLink to={'#'} id={idNamingConversion('Edit', 'supplierGroup', 'Link')} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                                }
                            </Space>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)}
                id={form?.id} loadTasks={() => loadTasks()} name={form?.name} url={'supplier-group'} title={'Supplier Group'} visible={deleteModal} />
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Supplier Group'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={supplierGroupDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}
export default SuppliersGroup